module.exports = __webpack_public_path__ + "static/media/handla-ikon-cc4132.921e2b02.png";